import { head, pipe } from '@fxts/core';

export const getBase64ThumbnailForNessFrame = (is_mobile: boolean): string | undefined => {
  if (is_mobile) {
    const image_el: HTMLImageElement = pipe(
      document.querySelectorAll('.pd-preview .pd-preview__item .mp-product-img'),
      head,
    ) as HTMLImageElement;
    if (!image_el) {
      throw new Error('썸네일이 존재하지 않습니다.');
    }
    return image_el.src;
  } else {
    const image_el: HTMLImageElement = pipe(
      document.querySelectorAll('.pd-preview .pd-preview__swiper .swiper-slide .mp-product-img'),
      head,
    ) as HTMLImageElement;
    if (!image_el) {
      throw new Error('썸네일이 존재하지 않습니다.');
    }
    return image_el.src;
  }
};
